<template>
  <div class="tag-input w-full pb-6">
    <div v-for="(tag, index) in tags" :key="tag" class="tag-input__tag bg-indigo-600 text-white text-sm">
      <span class="deleteCheck" @click="removeTag(index)">x</span>
      {{ tag }}
    </div>
    <input
      id="tagInput"
      type="text"
      placeholder="Enter a Tag"
      class="tag-input__text text-sm"
      @keydown.enter="addTag"
      @keydown.,="addTag"
      @keydown.delete="removeLastTag"
      @input="$emit('update:tags', $event.target.value)"
    />
  </div>
</template>
<script>
export default {
  props:{
    error: String,
    label: String,
    modelValue: Array,
  },
  emits: ['update:tags'],
  data () {
    return {
      tags: this.modelValue,
    }
  },
  methods: {
    addTag (event) {
      event.preventDefault()
      var val = event.target.value.trim()
      if (val.length > 0) {
        this.tags.push(val)
        event.target.value = ''
        this.$emit('update:tags', event.target.value)
      }
    },
    removeTag (index) {
      this.tags.splice(index, 1)
    },
    removeLastTag(event) {
      if (event.target.value.length === 0) {
        this.removeTag(this.tags.length - 1)
      }
    }
  }
}
</script>
<style>
.tag-input {
  width: 100%;
  /* border: 1px solid #eee; */
  /* font-size: 0.9em; */
  height: 50px;
  box-sizing: border-box;
  padding: 0 10px;
  margin-right:25px;
}

.tag-input__tag {
  height: 30px;
  float: left;
  margin-right: 10px;
  /* background-color: #eee; */
  margin-top: 10px;
  line-height: 30px;
  padding: 0 10px;
  border-radius: 5px;
}

.tag-input__tag > span {
  cursor: pointer;
  opacity: 0.75;
}

.tag-input__text {
  border: none;
  outline: none;
  line-height: 50px;
  background: none;
}
.deleteCheck {
  padding: 0 5px 0 5px;
  font-weight:800;
}
</style>
